module.exports = __webpack_public_path__ + "static/media/wash_hygiene_important.6b7f4c9a.svg";